import React from "react";
import libFloat from "../../../../util/libFloat";

export function ResumoFinanceiroVenda({ venda }) {
	if (!venda) return null;
	const formatCurrency = (val) => libFloat.strToCurrency(val || 0);

	return (
		<div className="mb-2">
			<h2 className="text-lg font-bold text-[#1e3a8a] mb-2 uppercase tracking-wide">
				Resumo Financeiro
			</h2>
			
			<div className="flex gap-12 mb-4 px-2 mt-4">
				<div>
					<p className="text-xs text-gray-500 font-bold uppercase mb-1">Valor Bruto</p>
					<p className="font-bold text-gray-800">{formatCurrency(venda.valorvenda)}</p>
				</div>
				{venda.desconto > 0 && (
					<div>
						<p className="text-xs text-gray-500 font-bold uppercase mb-1">(-) Desconto</p>
						<p className="font-bold text-gray-800 text-red-600">{formatCurrency(venda.desconto)}</p>
					</div>
				)}
				{venda.acrescimo > 0 && (
					<div>
						<p className="text-xs text-gray-500 font-bold uppercase mb-1">(+) Acréscimos / Taxas</p>
						<p className="font-bold text-gray-800 text-blue-600">
							{formatCurrency((venda.acrescimo || 0) + (venda.taxaservico || 0) + (venda.couvert || 0))}
						</p>
					</div>
				)}
				{venda.valorentrega > 0 && (
					<div>
						<p className="text-xs text-gray-500 font-bold uppercase mb-1">(+) Entrega</p>
						<p className="font-bold text-gray-800 text-purple-600">{formatCurrency(venda.valorentrega)}</p>
					</div>
				)}
			</div>

			<div className="bg-[#f0f4fb] px-4 py-3 flex justify-between items-center rounded-xl">
				<span className="text-[#1e3a8a] font-bold uppercase tracking-wide">Total da Venda:</span>
				<span className="text-[#1e3a8a] font-bold text-xl">{formatCurrency(venda.valor)}</span>
			</div>
		</div>
	);
}
